import { FC } from "react";

const DatabaseTipsRecommend: FC = () => {
  return (
    null
  )
}

export default DatabaseTipsRecommend;
